






import { Component, Vue } from 'vue-property-decorator';
import MemberProfilePage from '@/views/Performance/CustomerDetail.vue';

@Component({
  components: {
    MemberProfilePage
  }
})
export default class MemberProfile extends Vue {}
